import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { apiAction } from '../../store/generalSlice';
import Spinner from '../../layout/Spinner';

const TestRangeQuery = () => {
  const dispatch = useDispatch();
  const { condition_id } = useParams();
  const { condition, testRangeQuery } = useSelector((state) => state.general);

  useEffect(() => {
    dispatch(
      apiAction({
        reduxField: 'condition',
        route: `conditions/getConditionById`,
        conditionId: condition_id,
      })
    );
    dispatch(
      apiAction({
        reduxField: 'testRangeQuery',
        route: 'conditions/activateRangeQuery',
        conditionId: condition_id,
        setLoading: 'loadingTestRangeQuery',
      })
    );
  }, []);

  const columns = Array.isArray(testRangeQuery) && testRangeQuery.length ? Object.keys(testRangeQuery[0]) : [];

  console.log({ condition, testRangeQuery });
  return condition?._id ? (
    <div>
      <div className='row justify-content-left align-items-center mt-2'>
        <div className='col-md-12'>
          <Link className='btn btn-sm btn-outline-dark border-0' to={`/editRangeQuery/${condition._id}`}>
            Back to Edit Range Query
          </Link>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <div
          className='col-lg-12 d-flex justify-content-center mt-2 pt-lg-0 border-bottom'
          data-aos='fade-up'
          data-aos-delay='200'
        >
          <h1>Test Range Query</h1>
        </div>
      </div>
      <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
        <div className='container'>
          <h5>
            <Link className='text-primary' to={`/condition/${condition._id}`}>
              {condition.name}
            </Link>
          </h5>
        </div>
      </div>
      {Array.isArray(testRangeQuery) ? (
        <>
          <div className='row d-flex justify-content-center mt-4 pt-lg-0'>
            <h4>Found ({testRangeQuery.length}) Rows</h4>
          </div>
          <div className='row d-flex justify-content-center mt-4 pt-lg-0 p-4'>
            {(() => {
              return (
                <Box style={{ height: 600, width: '100%' }}>
                  <DataGrid
                    rows={testRangeQuery.map((row, id) => {
                      return { id, ...row };
                    })}
                    columns={columns.map((col) => {
                      return { field: col, header: col, width: 250 };
                    })}
                    pageSize={5}
                    rowsPerPageOptions={[5]}
                    //   checkboxSelection
                    disableSelectionOnClick
                  />
                </Box>
              );
            })()}
          </div>
        </>
      ) : (
        <Spinner />
      )}
    </div>
  ) : (
    <Spinner />
  );
};

export default TestRangeQuery;
